import { Model, ObservableList, ViewModel } from '@neos/core'
import { DataType } from '@neos/shared'
import { CustomViewContentAlign } from '@src/enums/CustomViewContentAlign'

/**
 * Represents CustomUIViewPropertyUI.
 */
export default class CustomUIViewPropertyUI extends Model {
  /**
   * Initializes a new instance of the CustomUIViewPropertyUI class.
   * 
   * @param item Item.
   * @param viewModel ViewModel.
   */
  constructor(item?: Record<string, unknown>, viewModel?: ViewModel<CustomUIViewPropertyUI>) {
    super({
      $new: !item,
      datagridFrozen: false,
      datagridMovable: false,
      datagridVisible: false,
      ellipsis: false,
      formVisible: false,
      id: 0,
      readonly: false,
      required: false,
      tabStop: false,
      ...item
    }, viewModel)
  }

  /**
   * Gets or sets Caption.
   */
  caption?: Record<string,string> | null

  /**
   * Gets or sets Created at.
   */
  createdAt?: Date | null

  /**
   * Gets or sets Created by.
   */
  createdBy?: string | null

  /**
   * Gets or sets Caption.
   */
  datagridCaption?: Record<string,string> | null

  /**
   * Gets or sets Width.
   */
  datagridColumnWidth?: string | null

  /**
   * Gets or sets Frozen.
   */
  datagridFrozen: boolean

  /**
   * Gets or sets Movable.
   */
  datagridMovable: boolean

  /**
   * Gets or sets Position.
   */
  datagridPosition?: number | null

  /**
   * Gets or sets Visible.
   */
  datagridVisible: boolean

  /**
   * Gets or sets Ellipsis.
   */
  ellipsis: boolean

  /**
   * Gets or sets Visible.
   */
  formVisible: boolean

  /**
   * Gets or sets Horizontal alignment.
   */
  horizontalAlign?: CustomViewContentAlign | null

  /**
   * Gets or sets Identifier.
   */
  id: number

  /**
   * Gets or sets Property Name.
   */
  name?: string | null

  /**
   * Gets or sets Read only.
   */
  readonly: boolean

  /**
   * Gets or sets Required.
   */
  required: boolean

  /**
   * Gets or sets Tab stop.
   */
  tabStop: boolean

  /**
   * Gets or sets Updated at.
   */
  updatedAt?: Date | null

  /**
   * Gets or sets Updated by.
   */
  updatedBy?: string | null

  /**
   * Gets or sets Custom view identifier.
   */
  customUIViewId?: string | null

  /**
   * Gets or sets $keyProperties.
   */
  static $keyProperties = new Set(['id'])

  /**
   * Gets or sets $properties.
   */
  static $properties = new Map([['createdAt', { dataType: DataType.dateTime, }], ['updatedAt', { dataType: DataType.dateTime, }]])
}